import CrossNew from '../../../foundations/tc-icons/dist/cross-new.vue.js';

//
var scrollPosition = 0;
var $body = document.querySelector('body');
var $closeButtonColors = ['purple', 'black', 'white'];

var script = {
  name: 'TcModal',
  components: {
    CrossNew: CrossNew
  },
  data: function data() {
    return {
      visible: false
    }
  },
  model: {
    prop: 'visible',
    event: 'set-visible'
  },
  props: {
    closeButton: {
      type: Boolean,
      default: true
    },
    closeButtonColor: {
      type: String,
      default: 'purple'
    },
    hasPadding: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    iconClass: function iconClass() {
      if (!$closeButtonColors.includes(this.closeButtonColor))
        { return 'tc-modal__icon--purple' }
      return ['tc-modal__icon', ("tc-modal__icon--" + (this.closeButtonColor))]
    }
  },
  methods: {
    showModal: function showModal() {
      this.freezeParent();
      this.visible = !this.visible;
    },
    hideModal: function hideModal() {
      this.visible = !this.visible;
      this.unfreezeParent();
    },
    focusCloseButton: function focusCloseButton() {
      this.$refs.closeButton.focus();
    },
    focusOverlay: function focusOverlay() {
      this.$refs.overlay.focus();
    },
    freezeParent: function freezeParent() {
      scrollPosition = window.pageYOffset;
      $body.style.overflow = 'hidden';
      $body.style.position = 'fixed';
      $body.style.top = "-" + scrollPosition + "px";
    },
    unfreezeParent: function unfreezeParent() {
      $body.removeAttribute('style');
      window.scrollTo(0, scrollPosition);
    },
    setPadding: function setPadding(elem) {
      if (this.hasPadding) { return (elem + "--has-padding") }
      if (!this.hasPadding) { return (elem + "--no-padding") }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.unfreezeParent();
  }
};

export default script;
